import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';
import NewsDetailTemplate, {
	getServerSideProps as newsDetailProps
} from './@_id/[[...name]]';
import NewsCatalogTemplate, {
	getServerSideProps as newsCatalogProps
} from './@rubric/[[...rubric]]';

const TEMPLATES_HASH = {
	detail: NewsDetailTemplate,
	catalog: NewsCatalogTemplate
};

export async function getServerSideProps({ query, ...rest }) {
	const validationSchema = Joi.object().keys({
		pathParams: Joi.array().items(Joi.string())
	});

	const params = Joi.attempt(query, validationSchema, {
		stripUnknown: true
	});

	const { pathParams = [] } = params;
	const [pathParam, possibleName, ...restPathParams] = pathParams;

	const isNumber = Boolean(pathParam) && !Number.isNaN(Number(pathParam));

	if (isNumber) {
		const props = newsDetailProps({
			...rest,
			query: {
				pathParams: restPathParams,
				_id: pathParam,
				name: possibleName
			},
			params: {
				...rest.params,
				_id: pathParam,
				name: possibleName
			}
		});
		return props;
	}

	const props = newsCatalogProps({
		query: {
			...query,
			rubric: pathParam || undefined
		},
		...rest,
		params: {
			...rest.params,
			rubric: pathParam || undefined
		}
	});
	return props;
}

const RedirectPage = (props) => {
	const Template = TEMPLATES_HASH[props.template];

	return <Template {...props} />;
};

RedirectPage.propTypes = {
	template: PropTypes.string
};

export default RedirectPage;
